import type { WalletDetailsItemKey } from '../../../state/WalletDetailsSlice';

export function createWalletDetailsItemHash(
  blockchain: string,
  address: string,
): WalletDetailsItemKey {
  return `${blockchain}-${address}`;
}
